import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { DocumentViewVisualStore } from '../stores';

type Props = {
    store: DocumentViewVisualStore;
};

const ImageViewer: React.FC<Props> = ({ store }) => {
    const [imageUrl, setImageUrl] = React.useState('');

    React.useEffect(() => {
        if (!store.fileBlob) {
            setImageUrl('');
            return;
        }

        const objectUrl = URL.createObjectURL(store.fileBlob);
        setImageUrl(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [store.fileBlob]);

    return (
        <div className="document-viewer-container">
            <div className="document-viewer-info-header">Document name: {store.file?.name || 'N/A'}</div>
            <div className="document-viewer-image-container">
                {imageUrl && <img className="document-viewer-image" src={imageUrl} alt={store.file?.name || ''} />}
            </div>
        </div>
    );
};

export default observer(ImageViewer);
